import { useEffect } from 'react';
import { MINDSET_OPEN_WITH_MESSAGE_EVENT, consumePendingOpenMessage } from 'utils/mindset';
export function useOpenMindsetWithMessageEvent(handleOpen) {
  useEffect(function () {
    // Consume any message that was dispatched before this listener registered
    // (e.g. on a cold page load where the sidebar mounts after useCoachDeepLink fires).
    var pending = consumePendingOpenMessage();
    if (pending) {
      handleOpen(pending.message, pending.silent, pending.threadTitle, pending.coachingContext);
    }
    function onOpenWithMessage(e) {
      // Clear the pending buffer so it isn't replayed when this effect
      // re-runs after handleOpen's identity changes (setHasInitialized).
      consumePendingOpenMessage();
      var _detail = e.detail,
        message = _detail.message,
        silent = _detail.silent,
        threadTitle = _detail.threadTitle,
        coachingContext = _detail.coachingContext;
      handleOpen(message, silent !== null && silent !== void 0 ? silent : false, threadTitle !== null && threadTitle !== void 0 ? threadTitle : '', coachingContext !== null && coachingContext !== void 0 ? coachingContext : '');
    }
    window.addEventListener(MINDSET_OPEN_WITH_MESSAGE_EVENT, onOpenWithMessage);
    return function () {
      return window.removeEventListener(MINDSET_OPEN_WITH_MESSAGE_EVENT, onOpenWithMessage);
    };
  }, [handleOpen]);
}